/* June & Louise productpagina: bij een variantwissel (1) de gekozen waarde achter elk optielabel bijwerken ("Size — M") en
   (2) de voorraadregel "Only X left in stock!" per variant herberekenen met dezelfde husselformule als in Liquid. Geen externe code. */
(function () {
  function lowStock(id) {
    var k = Math.floor(id / 32768) % 1000003;
    var h = (k * k + 700001) % 1000003;
    h = (h * h + 40009) % 1000003;
    var v = Math.floor(h / 1000);
    return ((h + v) % 7) + 3;
  }
  function update(form) {
    var section = form.closest('[data-section-type="product"], .product-section, .modal__inner') || document;
    var select = form.querySelector('select[name="id"]') || section.querySelector('select[name="id"]');
    if (select) {
      var id = parseInt(select.value, 10);
      var box = section.querySelector('[data-jl-lowstock]');
      if (box && id) {
        var tpl = box.getAttribute('data-template') || 'Only {count} left in stock!';
        var txt = box.querySelector('[data-jl-lowstock-text]');
        if (txt) txt.textContent = tpl.replace('{count}', String(lowStock(id)));
      }
    }
    /* De maatknoppen staan buiten het <form> (form-attribuut): form.elements bevat ze wel, form.querySelectorAll niet. */
    var inputs = Array.prototype.filter.call(form.elements || [], function (e) { return e.matches && e.matches('[data-variant-input]:checked'); });
    if (!inputs.length && section !== document) inputs = section.querySelectorAll('[data-variant-input]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var wrap = inp.closest('.variant-wrapper');
      if (!wrap) continue;
      var val = wrap.querySelector('[data-jl-option-value]');
      if (val) val.textContent = inp.value;
    }
  }
  function bind(form) {
    if (!form || form.getAttribute('data-jl-pdp')) return;
    form.setAttribute('data-jl-pdp', '1');
    var run = function () { window.setTimeout(function () { update(form); }, 50); };
    form.addEventListener('change', run);
    /* Knoppen buiten het form: hun change-event komt niet langs het form, dus daar ook direct op luisteren. */
    var radios = Array.prototype.filter.call(form.elements || [], function (e) { return e.matches && e.matches('[data-variant-input]'); });
    for (var r = 0; r < radios.length; r++) {
      if (!form.contains(radios[r])) radios[r].addEventListener('change', run);
    }
    update(form);
  }
  function init(root) {
    var forms = (root || document).querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }
  /* Sterrenregel: naar de reviews scrollen (sectie-id is template-afhankelijk) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.jl-rating__link');
    if (!a) return;
    var t = document.querySelector('[data-section-type="testimonials"], .testimonials-section, [id*="__testimonials"]');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  /* Quick shop: de modal wordt pas gevuld na het openen */
  document.addEventListener('click', function () { window.setTimeout(function () { init(); }, 600); });

  /* Snelheid (21 okt): productfoto's 2..n (class jl-lazy-later, zie snippets/media.liquid) pas laden na de eerste
     interactie of zodra de pagina klaar is, zodat de eerste weergave niet vijf grote foto's tegelijk ophaalt. */
  var released = false;
  function releaseLater() {
    var imgs = document.querySelectorAll('img.jl-lazy-later');
    for (var i = 0; i < imgs.length; i++) { imgs[i].classList.remove('jl-lazy-later'); imgs[i].classList.add('lazyload'); }
    if (imgs.length) released = true;
  }
  window.jlReleaseLater = releaseLater;
  function onFirstInteraction() { releaseLater(); }
  ['touchstart', 'pointerdown', 'keydown', 'wheel', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, onFirstInteraction, { passive: true, once: true });
  });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) releaseLater(); });
  function afterLoad() {
    if (window.requestIdleCallback) window.requestIdleCallback(function () { releaseLater(); }, { timeout: 2500 });
    else window.setTimeout(releaseLater, 1500);
    /* Galerij-hoogte-vloer (CSS --jl-ar) loslaten zodra de slider staat */
    window.setTimeout(function () {
      var m = document.querySelectorAll('.product__main-photos');
      for (var i = 0; i < m.length; i++) m[i].classList.add('jl-ready');
    }, 800);
  }
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
  document.addEventListener('shopify:section:load', function () { releaseLater(); });
})();
